import React from 'react'
import IframeCommunication from './IframeCommunication'

const WithIframeCommunication = WrappedComponent => ({ onReceiveMessage, targetOrigin, ...props }) => (
    <IframeCommunication onReceiveMessage={onReceiveMessage} targetOrigin={targetOrigin}>
        ({sendMessage}) => <WrappedComponent {...props} sendMessage={sendMessage} />
    </IframeCommunication>
)

export default WithIframeCommunication
